#import "../../../../../../common/graphql/EntityDocumentsFields.graphql"

query AttachablePaymentDocuments(
  $first: Int
  $after: Cursor
  $payCycleId: UUID!
  $paymentId: UUID
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachablePaymentDocuments(
    first: $first
    after: $after
    payCycleId: $payCycleId
    paymentId: $paymentId
    documentTypeId: $documentTypeId
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      ...EntityDocumentsFields
      # _documentContents
      # _isAccountingDocument
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
